module.exports = __webpack_public_path__ + "static/media/free_parking_on_premises.8c2ab8e0.svg";